import { render, staticRenderFns } from "./infoAddress1.vue?vue&type=template&id=c31c3cac&scoped=true"
import script from "./infoAddress1.vue?vue&type=script&lang=js"
export * from "./infoAddress1.vue?vue&type=script&lang=js"
import style0 from "./infoAddress1.vue?vue&type=style&index=0&id=c31c3cac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c3cac",
  null
  
)

export default component.exports